import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-sm">影视爱好者都在讨论的热门标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <div
              key={topic.name}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${topic.color} cursor-pointer hover:opacity-80 transition-opacity`}
            >
              <span className="text-sm font-medium whitespace-nowrap">#{topic.name}</span>
              <span className="text-xs opacity-60">{topic.count}讨论</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}